"use strict";

module.exports = {
  version: '9.0.1300'
};